import React, { useState } from 'react';
import { useUrlLocalizer, useTranslator } from 'tradera-lang/translate';
import ALink from 'tradera-components/alink/alink';
import { trackContainerClick } from '../analytics';
import './favourite-sellers.scss';
import LazyLoad from 'react-lazyload';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import Analytics from 'packages/analytics';
import { Button } from 'tradera-components/atoms/button/button';
import { postFavoriteSeller } from '../../vip/api/vip-api';

const FavouriteSellerCard = ({
    sellerAlias,
    sellerId,
    sellerProfileUrl,
    matchedItems,
    heroImageUrl,
    items,
    isSuggestion = false
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <div className="favourite-seller-card">
            <div className="d-flex align-items-start">
                {!!heroImageUrl && (
                    <ALink
                        href={toLocalizedUrl(`${sellerProfileUrl}`)}
                        className="mr-1"
                        onClick={() => {
                            trackContainerClick(
                                'favouriteSeller',
                                'Favourite Seller Card image'
                            );

                            if (isSuggestion) {
                                Analytics.trackEvent({
                                    category: 'SellerSuggestion',
                                    action: 'NavigateProfile',
                                    label: `${sellerId}:${sellerAlias}`
                                });
                            }
                        }}>
                        <LazyLoad style={{ height: '3rem', width: '3rem' }}>
                            <img
                                className="favourite-seller-card-image"
                                loading="lazy"
                                src={`https://img.tradera.net/heroimages/small-square/${heroImageUrl}`}
                                alt={sellerAlias}
                            />
                        </LazyLoad>
                    </ALink>
                )}
                <div className="mr-auto" style={{ minWidth: 0 }}>
                    <h5 className="seller-alias text-truncate mb-0">
                        <ALink
                            className="text-styled text-dark"
                            href={toLocalizedUrl(`${sellerProfileUrl}`)}
                            onClick={() => {
                                trackContainerClick(
                                    'favouriteSeller',
                                    'Favourite Seller Card title'
                                );

                                if (isSuggestion) {
                                    Analytics.trackEvent({
                                        category: 'SellerSuggestion',
                                        action: 'NavigateProfile',
                                        label: `${sellerId}:${sellerAlias}`
                                    });
                                }
                            }}
                            title={sellerAlias}
                            useLink={true}>
                            {sellerAlias}
                        </ALink>
                    </h5>
                    <ALink
                        className="text-truncate text-dark d-block"
                        href={toLocalizedUrl(`${sellerProfileUrl}`)}
                        onClick={() => {
                            trackContainerClick(
                                'favouriteSeller',
                                'Favourite Seller Card item count'
                            );

                            if (isSuggestion) {
                                Analytics.trackEvent({
                                    category: 'SellerSuggestion',
                                    action: 'NavigateProfile',
                                    label: `${sellerId}:${sellerAlias}`
                                });
                            }
                        }}
                        useLink={true}>
                        {t('startPage_favouriteSellers_sellerCard_count', {
                            count: matchedItems
                        })}
                    </ALink>
                </div>
                {isSuggestion && (
                    <SuggestedSellerToggle
                        sellerId={sellerId}
                        className="ml-1 flex-shrink-0"
                    />
                )}
            </div>
            {items && items.length > 0 && (
                <div className="favourite-seller-card-items mt-1 d-flex position-relative">
                    <div
                        className="position-absolute h-100 w-100 d-flex"
                        style={{ top: 0, left: 0 }}>
                        <LazyLoad>
                            {items.map(item => (
                                <ALink
                                    className="mini-image-card"
                                    href={toLocalizedUrl(item.itemUrl)}
                                    key={item.itemId}
                                    onClick={() => {
                                        trackContainerClick(
                                            'favouriteSeller',
                                            'Favourite Seller Card item'
                                        );

                                        if (isSuggestion) {
                                            Analytics.trackEvent({
                                                category: 'SellerSuggestion',
                                                action: 'NavigateItem',
                                                label: `${sellerId}:${sellerAlias}/${item.itemId}`
                                            });
                                        }
                                    }}
                                    useLink={true}>
                                    <img
                                        loading="lazy"
                                        src={item.imageUrl.replace(
                                            '/thumbs/',
                                            '/small-fit/'
                                        )} // TODO: Use correct image size.
                                        title={item.shortDescription}
                                        alt={item.shortDescription}
                                    />
                                </ALink>
                            ))}
                        </LazyLoad>
                    </div>
                </div>
            )}
        </div>
    );
};

const trackFavoriteSellerClick = (sellerId, wasFavouriteSeller) => {
    GtmService.trackAction(
        'SellerSuggestion',
        `${wasFavouriteSeller ? 'Remove' : 'Add'} favourite seller`,
        `SellerId: ${sellerId}`
    );
};

const SuggestedSellerToggle = ({
    sellerId,
    className = '',
    isFavouriteSeller = false
}) => {
    const { t } = useTranslator();
    const [isFavoriteSeller, setFavoriteSeller] = useState(isFavouriteSeller);
    const toggleFavoriteSeller = async (sellerId, isAlreadySaved) => {
        const data = await postFavoriteSeller(sellerId, isAlreadySaved);
        if (data && data.status === 200) {
            setFavoriteSeller(!isFavoriteSeller);
        }
    };
    return (
        <Button
            theme="dark"
            outline={!isFavoriteSeller}
            nowrap
            className={className}
            onClick={() => {
                trackFavoriteSellerClick(sellerId, isFavoriteSeller);
                toggleFavoriteSeller(sellerId, isFavoriteSeller);
            }}
            data-test-favorite-seller>
            {isFavoriteSeller ? (
                <div data-test-favorite-seller-added>{t('vip_following')}</div>
            ) : (
                <div data-test-favorite-seller-add>{t('vip_follow')}</div>
            )}
        </Button>
    );
};

export default FavouriteSellerCard;
